export default __webpack_public_path__ + "static/media/logo.3a5a211e.png";